/**
 * Shared fuel / carburant gauge contract used by the admin dashboard and the
 * mobile pickup/delivery forms so both render the same number of indicators.
 */

/** Number of fuel gauge indicators/segments (0 = empty, FUEL_LEVELS = full). */
export const FUEL_LEVELS = 8;

/** Lowest fuel value (empty tank). */
export const FUEL_MIN = 0;

/** Highest fuel value (full tank). */
export const FUEL_MAX = FUEL_LEVELS;

/** 1-based marker labels for each fuel indicator. */
export const FUEL_INDICATORS = [1, 2, 3, 4, 5, 6, 7, 8] as const;
